import { useLocation, useNavigate } from 'react-router-dom'
import type { BaseModalProps } from '../../Modal/BaseModal.js'
import { BaseModal } from '../../Modal/BaseModal.js'

export function UserMustSignupModal(props: BaseModalProps) {
  const location = useLocation()
  const navigate = useNavigate()

  const goToRegistration = () => {
    const encodedRedirect = encodeURIComponent(location.pathname + location.search)
    navigate(`/register?redirect=${encodedRedirect}`)
  }

  return (
    <BaseModal onClose={props.onClose} isOpen={props.isOpen}>
      <div className="modal-box">
        <h3 className="font-bold text-lg">Signup for Spcfy</h3>
        <p className="py-4">This feature is only available for registered Spcfy users.</p>
        <p className="py-4">
          Registered users can manage their orders submitted to partner labs, perform cross-order evaluations, and collaborate on
          multi-partner projects.
        </p>
        <p className="py-4">Sounds good? We think so, too! Head over and get started.</p>
        <div className="modal-action flex flex-col sm:flex-row justify-end gap-2">
          <form method="dialog">
            <button className="btn btn-outline">Good to know!</button>
          </form>
          <button className="btn btn-primary" onClick={goToRegistration}>
            Go to registration
          </button>
        </div>
      </div>
    </BaseModal>
  )
}
